import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import SessionContext from 'context/SessionContext';
import { isFavorite, toggleFavorite } from '../utils/favoriteUtils';

function SidebarItem(props) {
  const session = React.useContext(SessionContext);
  const [isFav, setIsFav] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  // Verificar estado inicial de favorito
  useEffect(() => {
    setIsFav(isFavorite(props.path));
  }, [props.path]);

  // Verificar si algún subitem está activo para expandir automáticamente
  useEffect(() => {
    if (props.subItems && props.location) {
      const hasActiveSubItem = props.subItems.some(subItem => {
        const subPath = subItem.path || subItem;
        return (
          props.location.pathname === subPath ||
          props.location.pathname.indexOf(`${subPath}/`) > -1
        );
      });
      if (hasActiveSubItem) {
        setIsExpanded(true);
      }
    }
  }, [props.subItems, props.location]);

  if (!props.can || !session.can(props.can)) return null;

  // Filtrar subitems por permisos
  const visibleSubItems = props.subItems
    ? props.subItems.filter(subItem => {
      const subItemObj = typeof subItem === 'object' ? subItem : { path: subItem, can: props.can };
      return !subItemObj.can || session.can(subItemObj.can);
    })
    : [];

  const hasSubItems = visibleSubItems.length > 0;

  const handleClick = e => {
    if (hasSubItems) {
      // Si tiene subitems, expandir/colapsar
      e.preventDefault();
      setIsExpanded(!isExpanded);
    } else {
      // Si no tiene subitems, navegar normalmente
      e.preventDefault();
      props.clearSearch();
      if (props.path) {
        props.history.push(props.path);
      }
    }
  };

  const handleSubItemClick = (e, subItemPath) => {
    e.stopPropagation();
    props.clearSearch();
    props.history.push(subItemPath);
  };

  const handleFavoriteClick = (e) => {
    e.stopPropagation(); // Evitar que se propague al ítem completo
    const newState = toggleFavorite(props.path);
    setIsFav(newState);

    // Notificar al sidebar que se actualizaron los favoritos
    if (props.onFavoriteChange) {
      props.onFavoriteChange();
    }
  };

  const { history, location, isSubItem } = props;

  const isActiveRoute = path => {
    if (!location) return false;
    return (
      path === location.pathname || location.pathname.indexOf(`${path}/`) > -1
    );
  };

  const isSubItemActive = (subItemPath) => {
    if (!location) return false;
    return (
      location.pathname === subItemPath ||
      location.pathname.indexOf(`${subItemPath}/`) > -1
    );
  };

  const paddingLeft = isSubItem ? '32px' : '16px';
  const subItemPaddingLeft = isSubItem ? '48px' : '48px';

  return (
    <div>
      <div
        className={`amber-sidebar-item ${isActiveRoute(props.path) ? 'active' : ''} ${isSubItem ? 'sub-item' : ''}`}
        onClick={handleClick}
        style={{
          padding: '10px 16px',
          paddingLeft: paddingLeft,
          cursor: 'pointer',
          color: 'white',
          backgroundColor: isActiveRoute(props.path) ? 'rgba(255,255,255,0.1)' : 'transparent',
          borderLeft: isActiveRoute(props.path) ? '3px solid white' : 'none',
          transition: 'all 0.2s ease',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <span style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
          <Icon name={props.icon} style={{ marginRight: '8px' }} />
          {props.label}
          {hasSubItems && (
            <Icon
              name={isExpanded ? 'chevron down' : 'chevron right'}
              style={{
                marginLeft: '8px',
                fontSize: '0.8em',
                opacity: 0.7
              }}
            />
          )}
        </span>

        {!hasSubItems && (
          <Icon
            name={isFav ? 'star' : 'star outline'}
            onClick={handleFavoriteClick}
            style={{
              cursor: 'pointer',
              opacity: isFav ? 1 : 0.4,
              color: isFav ? '#FFD700' : 'white',
              transition: 'all 0.2s ease'
            }}
            className="favorite-toggle"
          />
        )}
      </div>

      {hasSubItems && isExpanded && (
        <div className="sidebar-subitems">
          {visibleSubItems.map((subItem, index) => {
            const subItemObj = typeof subItem === 'object'
              ? subItem
              : { path: subItem, label: subItem, icon: 'circle' };
            const subItemPath = subItemObj.path || subItem;
            const subItemLabel = subItemObj.label || subItem;
            const subItemIcon = subItemObj.icon || 'circle';

            return (
              <div
                key={index}
                className={`amber-sidebar-item sub-sub-item ${isSubItemActive(subItemPath) ? 'active' : ''}`}
                onClick={(e) => handleSubItemClick(e, subItemPath)}
                style={{
                  padding: '8px 16px',
                  paddingLeft: subItemPaddingLeft,
                  cursor: 'pointer',
                  color: 'white',
                  backgroundColor: isSubItemActive(subItemPath) ? 'rgba(255,255,255,0.1)' : 'transparent',
                  borderLeft: isSubItemActive(subItemPath) ? '3px solid white' : 'none',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontSize: '0.9em'
                }}
              >
                <span>
                  <Icon name={subItemIcon} style={{ marginRight: '8px', fontSize: '0.7em' }} />
                  {subItemLabel}
                </span>
                <Icon
                  name={isFavorite(subItemPath) ? 'star' : 'star outline'}
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite(subItemPath);
                    if (props.onFavoriteChange) {
                      props.onFavoriteChange();
                    }
                  }}
                  style={{
                    cursor: 'pointer',
                    opacity: isFavorite(subItemPath) ? 1 : 0.4,
                    color: isFavorite(subItemPath) ? '#FFD700' : 'white',
                    transition: 'all 0.2s ease',
                    marginLeft: '8px',
                    fontSize: '0.8em'
                  }}
                  className="favorite-toggle"
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default withRouter(SidebarItem);